class TSHeader extends HTMLElement {
  constructor() {
    super();
    this.headerHeight = this.getBoundingClientRect().height;
    this.mobileMenu = this.querySelector("#TSHeaderMobile");
    this.predictiveResults = this.querySelector(".ts-header__search-results");

    this.calcHeader();
    this.initScrollEvents();
    this.initClickEvents();

    if (this.predictiveResults) {
      this.initSubmitEvents();
      this.initOnInputEvents();
    }
  }

  calcHeader() {
    const headerObserver = new ResizeObserver(() => {
      const outer = document.querySelector(".ts-header__outer");
			this.headerHeight = this.getBoundingClientRect().height;
			document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);

      this.classList.toggle('sticky', window.scrollY >= (outer.getBoundingClientRect().top + window.scrollY));
		});

		headerObserver.observe(this);
  }

  toggleMenu() {
    this.mobileMenu.classList.toggle("open");
    document.documentElement.style.overflow = this.mobileMenu.classList.contains("open") ? "hidden" : null;
  }

  initScrollEvents() {
    window.addEventListener('scroll', () => {
      const outer = document.querySelector(".ts-header__outer");
      this.classList.toggle('sticky', window.scrollY >= (outer.getBoundingClientRect().top + window.scrollY));
    });
  }

  predictiveChange(query) {
    if (query === "") {
      this.predictiveResults.innerHTML = "";
      this.classList.remove("overlay");
      document.documentElement.style.overflow = null;
      return;
    }

    fetch(`/search/suggest?q=${encodeURIComponent(query.trim())}&resources[type]=product&section_id=ts-predictive-results`)
    .then(response => {
      if (!response.ok) {
        this.predictiveResults.innerHTML = "";
        this.classList.remove("overlay");
        document.documentElement.style.overflow = null;
        return;
      }

      return response.text();
    })
    .then(response => {
      const responseMarkup = new DOMParser().parseFromString(response, 'text/html');
      this.predictiveResults.innerHTML = responseMarkup.querySelector(".ts-predictive").innerHTML;
      this.classList.add("overlay");
      document.documentElement.style.overflow = "hidden";
    })
    .catch(error => {
      console.log("Something going wrong while fetch predictive", error);
    })
  }

  initSubmitEvents() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();
    })
  }

  initOnInputEvents() {
    this.querySelector("input[type='search']").addEventListener('input', debounce((e) => {
      this.predictiveChange(e.target.value);
    }, 500).bind(this))
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "menu-toggle":
            this.toggleMenu();
            break;
          case "close-search":
            this.predictiveResults.innerHTML = "";
            this.classList.remove("overlay");
            document.documentElement.style.overflow = null;
        }
      }
    })
  }
}

customElements.define("ts-header", TSHeader)